/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IComparisonAlbumImage } from './ComparisonAlbumImage';

export interface IComparisonAlbum {
  /** Заголовок альбома. **/
  title: string;
  /** Подзаголовок с количеством объектов. **/
  subtitle: string;
  /** Тип недвижимости. **/
  propertyType: EPropertyType;
  /** Список изображений для альбома. **/
  images: IComparisonAlbumImage[];
}

export enum EPropertyType {
  /** Объявление **/
  'Offer' = 'offer',
  /** Новостройка **/
  'Newbuilding' = 'newbuilding',
}
